import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dispatcherdelivery" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_5 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_delivery_modal = _resolveComponent("delivery-modal")!
  const _component_change_date_modal = _resolveComponent("change-date-modal")!
  const _component_delivery_verification_modal = _resolveComponent("delivery-verification-modal")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_delivery_order_list_item = _resolveComponent("delivery-order-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.delivery_close_state.opened)
      ? (_openBlock(), _createBlock(_component_delivery_modal, {
          key: 0,
          "delivery-id": _ctx.delivery_close_state.delivery_id,
          onCancel: _ctx.cancelDeliveryClose,
          onSubmited: _ctx.onDeliveryClosed
        }, null, 8, ["delivery-id", "onCancel", "onSubmited"]))
      : _createCommentVNode("", true),
    (_ctx.change_date_state.is_changing_date)
      ? (_openBlock(), _createBlock(_component_change_date_modal, {
          key: 1,
          "delivery-current": _ctx.change_date_state.delivery_current,
          onCancel: _ctx.toggleChangeDate,
          onChanged: _ctx.onDateChanged
        }, null, 8, ["delivery-current", "onCancel", "onChanged"]))
      : _createCommentVNode("", true),
    (_ctx.verification_state.opened)
      ? (_openBlock(), _createBlock(_component_delivery_verification_modal, {
          key: 2,
          "delivery-id": _ctx.verification_state.delivery_id,
          "company-id": _ctx.verification_state.company_id,
          "invoice-number": _ctx.verification_state.invoice_number,
          "phone-number": _ctx.verification_state.phone_number,
          onCancel: _ctx.cancelDeliveryVerification,
          onSubmited: _ctx.onDeliveryVerificationClosed
        }, null, 8, ["delivery-id", "company-id", "invoice-number", "phone-number", "onCancel", "onSubmited"]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.loadDeliveryList(_ctx.state.pagination.current_page)), ["prevent"])),
      class: "bg-white border px-6 py-4"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_select, {
          value: _ctx.filters_state.dispatchers_sector_id,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.dispatchers_sector_id) = $event)),
          placeholder: "Выберите сектор диспетчера",
          loading: _ctx.data_state.dispatchers_sectors.is_loading,
          options: _ctx.data_state.dispatchers_sectors.list,
          failed: _ctx.data_state.dispatchers_sectors.is_failed,
          "error-text": "При получении списка секторов диспетчера произошла ошибка",
          "search-by": "name",
          "select-by": "id",
          label: "name",
          onRefresh: _ctx.loadDispatchersSectors
        }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
        _createVNode(_component_the_select, {
          class: "mt-3",
          value: _ctx.filters_state.status,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.status) = $event)),
          options: _ctx.DELIVERY_STATUSES,
          searchable: false,
          "select-by": "id",
          label: "name",
          placeholder: "Статус"
        }, null, 8, ["value", "options"]),
        _createVNode(_component_the_select, {
          value: _ctx.filters_state.courier_id,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.courier_id) = $event)),
          placeholder: "Выберите курьера",
          label: "fullName",
          "search-by": "fullName",
          options: _ctx.data_state.couriers.list,
          loading: _ctx.data_state.couriers.is_loading,
          failed: _ctx.data_state.couriers.is_failed,
          "error-text": "При получении списка курьеров произошла ошибка",
          "infinite-scroll": "",
          onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCouriers(_ctx.data_state.couriers.pagination.current_page))),
          onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreCouriers(_ctx.data_state.couriers.pagination.current_page + 1))),
          onSearch: _ctx.searchCourier,
          onOptionBySearch: _ctx.unshiftFindedCourier,
          class: "mt-3"
        }, null, 8, ["value", "options", "loading", "failed", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_input, {
          placeholder: "Номер накладной",
          value: _ctx.filters_state.invoice_number,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.invoice_number) = $event)),
          disabled: _ctx.state.is_loading,
          class: "mt-1"
        }, null, 8, ["value", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_button, {
          class: "second small text mr-3",
          loading: _ctx.state.is_loading,
          onClick: _ctx.onFiltersReset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary small",
          loading: _ctx.state.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createVNode(_component_page_title, {
      class: "mt-6",
      title: "Список доставок"
    }),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка доставок произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadDeliveryList(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_list, {
            key: 1,
            loading: _ctx.state.is_loading,
            items: _ctx.state.list,
            pagination: "",
            "pagination-current-page": _ctx.state.pagination.current_page,
            "pagination-total-pages": _ctx.state.pagination.total_pages,
            onChangePage: _ctx.loadDeliveryList
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_delivery_order_list_item, {
                item: item,
                onDelivery: _ctx.startDeliveryClose,
                onDeliveryWithVerify: _ctx.startDeliveryVerification,
                onItemRemoved: _ctx.onOrderRemoved,
                onDate: _ctx.onChangeDate,
                onClosed: _ctx.loadDeliveryList
              }, null, 8, ["item", "onDelivery", "onDeliveryWithVerify", "onItemRemoved", "onDate", "onClosed"])
            ]),
            _: 1
          }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
    ])
  ]))
}